import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

function allowedCommittee(u, val) {
  if (val === "all") return true;
  if (u.role === "super_admin" || u.all_committees) return true;
  const nos = (u.committee_nos && u.committee_nos.length) ? u.committee_nos : (u.committee_no != null ? [u.committee_no] : []);
  return nos.includes(val);
}

function pickCommittee(u) {
  const saved = localStorage.getItem("imeak_committee");
  if (saved != null) {
    const val = saved === "all" ? "all" : Number(saved);
    if ((val === "all" || !Number.isNaN(val)) && allowedCommittee(u, val)) return val;
  }
  if (u.role === "super_admin" || u.all_committees) return "all";
  const nos = (u.committee_nos && u.committee_nos.length) ? u.committee_nos : (u.committee_no != null ? [u.committee_no] : []);
  if (nos.length > 1) return "all";
  return nos.length === 1 ? nos[0] : "all";
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const [committee, setCommittee] = useState(null); // selected committee_no or "all"

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem("imeak_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setCommittee(pickCommittee(data));
    } catch {
      localStorage.removeItem("imeak_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  // Persist the selected committee so it survives a full page reload / direct URL entry.
  useEffect(() => {
    if (committee != null) localStorage.setItem("imeak_committee", String(committee));
  }, [committee]);

  const login = (token, userObj) => {
    localStorage.setItem("imeak_token", token);
    setUser(userObj);
    setCommittee(pickCommittee(userObj));
  };

  const logout = () => {
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("imeak_token");
    localStorage.removeItem("imeak_committee");
    setUser(false);
  };

  const refreshUser = loadUser;

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, committee, setCommittee, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
